import React from 'react'
import Tooltip from '../popups/Tooltip'
import './IconLink.scss'

const IconLink = ({ icon, className, active, onClick, label, counter, counterClassname, variant, disabled }) => {
	return (
		<Tooltip disabled={!label} placement="right" label={label} delay={1000}>
			<div aria-label={label} className={`link-container${active ? " current-route" : ""}${className ? " " + className : ""}${variant ? ` variant-${variant}` : ''}${disabled ? ' disabled' : ''}`} onClick={disabled ? null : onClick}>
				{icon}
				{counter && counter > 0
					? <span className={`icon-counter-wrapper ${counterClassname ? counterClassname : ""}`}>
						{counter}
					</span>
					: ''
				}
			</div>
		</Tooltip>
	);
}

export default IconLink